// extracted by mini-css-extract-plugin
export default {"list":"EqKvs84ynat3d9G7hbg6"};